import { isEmpty } from "lodash";
import { useEffect, useState } from "react";

interface Props {
  driverData: any;
}

export default function DispatchTable({ driverData }: Props) {
  const [data, setData] = useState([]);
  const [driver, setDriver] = useState<string | null>(null);
  const [trailerData, setTrailerData] = useState<string | null>(null);
  const [vehicleData, setVehicleData] = useState<string | null>(null);

  useEffect(() => {
    if (driverData?.data?.length > 0) {
      setData(driverData.data);

      // Set values from the first row or use logic to determine what to show
      const firstRow = driverData.data[0];
      setDriver(firstRow?.first_name || null);
      setTrailerData(firstRow?.trailer || null);
      setVehicleData(firstRow?.vehicle || null);
    }
  }, [driverData]);

  return (
    <div className="relative overflow-x-auto">
      <h2 className="font-medium mb-2 uppercase">
        {(driver && "Drivers") ||
          (trailerData && "Trailer") ||
          (vehicleData && "Vehicle")}
      </h2>

      <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 border">
        <thead className="text-xs text-gray-700 uppercase bg-gray-200 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            {!isEmpty(driver) && (
              <th scope="col" className="px-6 py-2">
                Driver Name
              </th>
            )}
            {!isEmpty(vehicleData) && (
              <th scope="col" className="px-6 py-2">
                Vehicle
              </th>
            )}
            {!isEmpty(trailerData) && (
              <th scope="col" className="px-6 py-2">
                Trailer
              </th>
            )}
            <th scope="col" className="px-6 py-2">
              Location
            </th>
            <th scope="col" className="px-6 py-2">
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map(
            (
              {
                first_name,
                last_name,
                trailer,
                vehicle,
                terminal,
                status,
              }: any,
              index: number,
            ) => (
              <tr
                key={index}
                className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200"
              >
                {!isEmpty(driver) && (
                  <th
                    scope="row"
                    className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                  >
                    {first_name} {last_name}
                  </th>
                )}
                {!isEmpty(vehicleData) && (
                  <td className="px-6 py-2">{vehicle}</td>
                )}
                {!isEmpty(trailerData) && (
                  <td className="px-6 py-2">{trailer}</td>
                )}
                <td className="px-6 py-2">{terminal}</td>
                <td
                  className={`px-6 py-2 text-white ${
                    status === "Busy" ? "bg-red-500" : "bg-green-500"
                  }`}
                >
                  {status}
                </td>
              </tr>
            ),
          )}
        </tbody>
      </table>
    </div>
  );
}
